import React from 'react';
import { PAD, Reveal, SlideFrame, SlideHeader, t } from './primitives';
import { LEO_ASSETS } from './visuals';
const ANNOTATIONS = [{
  step: '01',
  title: 'Master campaign',
  description: 'One global concept, built once as reusable campaign assets'
}, {
  step: '02',
  title: 'Teasers & trailers',
  description: 'Content units cut for each channel, audience, and moment'
}, {
  step: '03',
  title: 'Localized Snaks',
  description: 'Translation, regulatory updates, and market adaptation'
}, {
  step: '04',
  title: 'In-market activation',
  description: 'Channel setup, launch, and performance feedback loop'
}];
export function CampaignAnatomy() {
  return <SlideFrame data-id="element-4" data-mp="36byrcyu21jqr">
      <div className={`flex h-full w-full flex-col ${PAD}`} data-id="element-5" data-mp="36ciaujzcsg6w">
        <SlideHeader eyebrow="06 — Campaign anatomy" title="Inside a" accent="LEO campaign flow" kicker="Snakker for LEO Pharma" data-id="element-6" data-mp="gm50p93e1re6" />

        <div className="mt-[3.2vh] grid min-h-0 flex-1 grid-cols-[1.55fr_1fr] gap-[1.4vw]" data-id="element-7" data-mp="2ynhyo5lxjn1m">
          <Reveal delay={0.2} className="flex min-h-0" data-id="element-8" data-mp="2ulwncop1ngtj">
            <figure className="flex min-h-0 w-full flex-col rounded-[0.9vw] border border-white/10 bg-white p-[1.1vw]" data-id="element-9" data-mp="2umegvdkbngxr">
              <img src={LEO_ASSETS.campaignFlow} alt="LEO example campaign flow diagram from master concept through localization to in-market activation" className="min-h-0 w-full flex-1 object-contain" data-id="element-10" data-mp="2powhoew3wg2y" />
              <figcaption className={`${t.label} mt-[1.2vh] shrink-0 uppercase tracking-[0.18em] text-black/45`} data-id="element-11" data-mp="2ax40rygnytz4">
                LEO example campaign — end-to-end flow
              </figcaption>
            </figure>
          </Reveal>

          <div className="flex min-h-0 flex-col gap-[1.2vh]" data-id="element-12" data-mp="1wxuubqi9fe8c">
            {ANNOTATIONS.map((item, index) => <Reveal key={item.step} delay={0.3 + index * 0.08} className="flex min-h-0 flex-1" data-id="element-13" data-mp="1ryrq28a3tc1f" data-mpi={index}>
                <div className="flex w-full items-center gap-[1.1vw] rounded-[0.6vw] border border-white/10 bg-white/[0.035] px-[1.3vw] py-[1.2vh]" data-id="element-14" data-mp="1ids4puydfsnc">
                  <span className={`${t.small} shrink-0 font-semibold text-[#A26BFF]`} data-id="element-15" data-mp="19bsnp2ncwoke">
                    {item.step}
                  </span>
                  <div className="min-w-0" data-id="element-16" data-mp="211nd0zb7se92">
                    <p className={`${t.small} font-semibold leading-[1.2] text-white`} data-id="element-17" data-mp="212oyzytrql5k">
                      {item.title}
                    </p>
                    <p className={`${t.body} mt-[0.6vh] leading-[1.35] text-white/55`} data-id="element-18" data-mp="1s93juedoz1vm">
                      {item.description}
                    </p>
                  </div>
                </div>
              </Reveal>)}
            <Reveal delay={0.66} className="shrink-0" data-id="element-19" data-mp="2osjbgfa6e7pa">
              <p className={`${t.label} border-t border-white/10 pt-[1.6vh] leading-[1.4] text-white/50`} data-id="element-20" data-mp="dcivkou5ie5p">
                Every market reuses the same master — no rebuild, no drift from global
                brand intent.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </SlideFrame>;
}